import React from 'react'
import Layout from '../layout'

import './legal.scss'

const Impressum = () => (
  <Layout>
    <section className="legal">
      <h1>Impressum</h1>
      <p>Angaben gemäß § 5 TMG</p>

      <h2>Kontakt</h2>
      <p className="contact">
        <strong>Architekturbüro Nolte</strong>
        <br />
        Renate Nolte
        <br />
        Arthur-Hoffmann-Str. 47
        <br />
        04107 Leipzig
        <br />
        <br />
        <strong>Telefon:</strong> +49 (0) 341 2610977
        <br />
        <strong>Telefax:</strong> +49 (0) 341 2610908
        <br />
        <strong>E-Mail:</strong> info@nolte-architektur.de
        <br />
      </p>

      <p>
        <b>Umsatzsteuer:</b>
        <br />
        Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:
        231/253/03528
      </p>

      <p>
        <b>Berufsbezeichnung und berufsrechtliche Regelungen</b> <br />
        Berufsbezeichnung: Architekt
        <br />
        Zuständige Kammer: Architektenkammer Sachsen
        <br />
        Verliehen durch: Deutschland
      </p>

      <p>
        <b>Es gelten folgende berufsrechtliche Regelungen:</b>
        <br />
        Baukammerngesetz sowie die dazu erlassene Durchführungsverordnung,
        Verordnung über Honorare für Leistungen der Architekten und Ingenieure
        (HOAI)
        <br />
        <b>Regelungen einsehbar unter:</b> http://www.dresden-aksachsen.org
      </p>

      <p>
        <b>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</b>
        <br />
        Inhaltlich Verantwortlicher gemäß §6 TDG: Renate Nolte
      </p>

      <h2>Haftung für Inhalte</h2>

      <p>
        Als Dienstanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf
        diesen Seiten nach den
        <br />
        allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
        Dienstanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte
        fremde Informationen zu überwachen oder nach Umständen zu forschen, die
        auf eine rechtswidrige Tätigkeit hinweisen.
        <br />
        Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
        Informationen nach den allgemeinen
        <br />
        Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist
        jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten
        Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
        <br />
        Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
      </p>

      <h2>Haftung für Links</h2>

      <p>
        Unser Angebot enthält keine Links zu externen Websites Dritter, auf
        deren Inhalte wir keinen Einfluss haben. Dennoch weisen wir darauf hin,
        dass wir für Links auf Websites Dritter für diese fremden Inhalte keine
        Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der
        jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Verlinkte
        Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße
        überprüft. Eine permanente inhaltliche Kontrolle der verlinkten Seiten
        ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht
        zumutbar.
      </p>

      <h2>Urheberrecht</h2>

      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
        Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
        Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
        Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
        jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite
        sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
      </p>

      <p>
        Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden,
        werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte
        Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
        Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
        entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden
        wir derartige Inhalte umgehend entfernen.
      </p>
    </section>
  </Layout>
)

export default Impressum
